export default __webpack_public_path__ + "static/media/d2a468353960505b7e3889eb7ff2aee2.svg";